import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { intl } from "../utils/i18nUtility";

var FormattedMessage = function FormattedMessage(_ref) {
  var id = _ref.id,
      values = _ref.values,
      defaultMessage = _ref.defaultMessage,
      variant = _ref.variant;
  var Tag = variant || Fragment;
  return React.createElement(Tag, null, intl.get(id, values, defaultMessage).d(defaultMessage));
};

FormattedMessage.defaultProps = {
  values: undefined,
  variant: undefined
};
FormattedMessage.propTypes = {
  /** The id for the message */
  id: PropTypes.string.isRequired,

  /** Dynamic values to set to the message string */
  values: PropTypes.shape(),

  /** Fallback message to localized message */
  defaultMessage: PropTypes.string.isRequired,

  /** set the moment component to be variant ('div','string'...) in stead of fragment */
  variant: PropTypes.string
};
export default FormattedMessage;